import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from '../../models/user';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'user-key': environment.apiKey,
        'X-Tenant-ID': environment.clientID
    })
};

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private endpoint: string;

    constructor(private http: HttpClient) {
        this.endpoint = environment.apiUrl;
    }

    getAll() {
        return this.http.get<User[]>(this.endpoint + `/users`, httpOptions);
    }

    getById(id: number) {
        return this.http.get(this.endpoint + `/users/${id}`, httpOptions);
    }

    register(user: User) {
        return this.http.post(this.endpoint + `/users/register`, user, httpOptions);
    }

    update(user: User) {
        return this.http.post(this.endpoint + `/users/update/${user.id}`, user, httpOptions);
    }

    delete(id: number) {
        return this.http.post(this.endpoint + `/users/delete/${id}`, '', httpOptions);
    }

    resetPassword(email: string) {
        return this.http.get(this.endpoint + `/users/resetpassword/${email}`, httpOptions);
    }
}
